<!-- =========================================================================================
    File Name: EmailSidebar.vue
    Description: Email Application Sidebar(Filter) (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="email__email-sidebar h-full">
        <div class="m-6 clearfix">
            <vs-button size="large" class="bg-primary-gradient w-full blockoPayBtn" icon-pack="feather" icon="icon-plus" @click="activePrompt = false" data-toggle="modal" data-uid=c0635b20d31a11e9 :data-extra="user_displayLogin">Novo BTC</vs-button>
        </div>

        <!-- compose email -->
        <vs-prompt
            class="email-compose"
            vs-title="Novo BTC"
            vs-accept-text= "Enviar"
            @vs-cancel="clearFields"
            @vs-accept="sendMail"
            @vs-close="clearFields"
            :vs-is-valid="validateForm"
            :vs-active.sync="activePrompt">
                <VuePerfectScrollbar class="scroll-area p-4" :settings="settings">
                    <form @submit.prevent>
                        <vs-input v-validate="'required|min:3'" name="mailSubject" label-placeholder="Nome do BTC" v-model="mailSubject" class="w-full mb-6" />
                        <span class="text-danger text-sm">{{ errors.first('mailSubject') }}</span>
						<vs-input v-validate="'required|min:3'" name="mailCC" label-placeholder="Valor do BTC" v-money="money" v-model="mailCC" class="w-full mb-6" />
                        <span class="text-danger text-sm">{{ errors.first('mailCC') }}</span>
						<quill-editor v-validate="'required|min:3'" v-model="mailMessage" :options="editorOption"></quill-editor>
                    </form>
                </VuePerfectScrollbar>
        </vs-prompt>

        <VuePerfectScrollbar class="email-scroll-area" :settings="settings">
            <div class="px-6 pb-2 flex flex-col">

                <div class="flex justify-between items-center cursor-pointer" :class="{'text-primary': mailFilter == 'aguardando_pagamento'}" @click="updateFilter('aguardando_pagamento')">
                    <div class="flex items-center mb-2">
                        <feather-icon icon="MehIcon" :svgClasses="[{'text-primary stroke-current': mailFilter == 'aguardando_pagamento'}, 'h-6 w-6']"></feather-icon>
                        <span class="text-lg ml-3">Aguardando Pagamento</span>
                    </div>
                    <vs-chip color="primary" v-if="totalMails('inboxed') > 0">{{ totalMails('inboxed') }}</vs-chip>
                </div>
                <div class="flex justify-between items-center mt-4 cursor-pointer" :class="{'text-primary': mailFilter == 'pago'}" @click="updateFilter('pago')">
                    <div class="flex items-center mb-2">
                        <feather-icon icon="SmileIcon" :svgClasses="[{'text-primary stroke-current': mailFilter == 'pago'}, 'h-6 w-6']"></feather-icon>
                        <span class="text-lg ml-3">Pago</span>
                    </div>
                    <vs-chip color="primary" v-if="totalMails('sent') > 0">{{ totalMails('sent') }}</vs-chip>
                </div>
               
                <div class="flex justify-between items-center mt-4 cursor-pointer" :class="{'text-primary': mailFilter == 'cancelado'}" @click="updateFilter('cancelado')">
                    <div class="flex items-center mb-2">
                        <feather-icon icon="XSquareIcon" :svgClasses="[{'text-primary stroke-current': mailFilter == 'cancelado'}, 'h-6 w-6']"></feather-icon>
                        <span class="text-lg ml-3">Cancelado</span>
                    </div>
                    <vs-chip color="primary" v-if="totalMails('drafted') > 0">{{ totalMails('drafted') }}</vs-chip>
                </div>
                <div class="flex justify-between items-center mt-4 cursor-pointer" :class="{'text-primary': mailFilter == 'bloqueado'}" @click="updateFilter('bloqueado')">
                    <div class="flex items-center mb-2">
                        <feather-icon icon="LockIcon" :svgClasses="[{'text-primary stroke-current': mailFilter == 'bloqueado'}, 'h-6 w-6']"></feather-icon>
                        <span class="text-lg ml-3">Bloqueado</span>
                    </div>
                    <vs-chip color="primary" v-if="totalMails('bloqueado') > 0">{{ totalMails('bloqueado') }}</vs-chip>
                </div>
                <div class="flex justify-between items-center mt-4 cursor-pointer" :class="{'text-primary': mailFilter == 'pendente'}" @click="updateFilter('pendente')">
                    <div class="flex items-center mb-2">
                        <feather-icon icon="GitPullRequestIcon" :svgClasses="[{'text-primary stroke-current': mailFilter == 'pendente'}, 'h-6 w-6']"></feather-icon>
                        <span class="text-lg ml-3">Pendente</span>
                    </div>
                    <vs-chip color="primary" v-if="totalMails('spam') > 0">{{ totalMails('spam') }}</vs-chip>
                </div>
                <div class="flex justify-between items-center mt-4 cursor-pointer" :class="{'text-primary': mailFilter == 'arquivado'}" @click="updateFilter('arquivado')">
                    <div class="flex items-center mb-2">
                        <feather-icon icon="BookIcon" :svgClasses="[{'text-primary stroke-current': mailFilter == 'arquivado'}, 'h-6 w-6']"></feather-icon>
                        <span class="text-lg ml-3">Arquivado</span>
                    </div>
                    <vs-chip color="primary" v-if="totalMails('trashed') > 0">{{ totalMails('trashed') }}</vs-chip>
                </div>
            </div>
        </VuePerfectScrollbar>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {VMoney} from 'v-money'

export default{
	directives: {money: VMoney},
    props: {
        emailTags: {
            type: Array,
            required: true,
        },
        mailFilter: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
			money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				suffix: '',
				precision: 2,
				masked: false /* doesn't work with directive */
			},
            activePrompt: false,
            mailTo: '',
            mailSubject: '',
            mailCC: '',
            mailBCC: '',
            mailMessage: '',
            editorOption: {
                modules: {
                    toolbar: [['bold', 'italic', 'underline', 'strike', 'link', 'blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered'}, { 'list': 'bullet' }], [{ 'font': [] }],],
                },
                placeholder: 'Descrição do BTC'
            },
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.30,
            },
        }
    },
    computed: {
		user_displayLogin() {
            return JSON.parse(localStorage.getItem('userInfo')).Login
        },
        validateForm() {
            return !this.errors.any();
        },
        unreadMails() {
            return (mailType) => this.$store.getters['btc/unreadMails'](mailType);
        },
        totalMails() {
            return (mailType) => this.$store.getters['btc/totalMails'](mailType);
        },
        draftMails() {
            return this.$store.getters['btc/NumdraftMails'];
        },
    },
    methods: {
        updateFilter(filterName) {
            this.$store.dispatch('btc/updateMailFilter', filterName);
            this.$emit('closeSidebar', false);
        },
        // compose mail methods
        clearFields() {
            this.mailTo = '';
            this.mailSubject = '';
            this.mailCC = '';
            this.mailBCC = '';
            this.mailMessage = '';
        },
        sendMail() {
			if(this.mailSubject.length <= 1)
			{
				this.$vs.notify({
					title: 'SPSaude',
					text: 'Preencha o nome do btc!',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				});
			}
			else
			{
				if(this.mailMessage.length <= 1)
				{
					this.$vs.notify({
						title: 'SPSaude',
						text: 'Preencha a descrição do btc!',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger'
					});
				}
				else
				{
					/*fetch(this.$store.state.API_URL + 'Saldo/Bc', {
						method: 'POST',
						headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
						body: "token="+localStorage.getItem("token")+"&nome_tev="+this.mailSubject+"&valor_tev="+this.mailCC+"&mensagem_tev="+this.mailMessage
					})
					.then((response) => response.text())
					.then((responseData) => {
						var dados = JSON.parse(responseData);
						
						if(dados.done == true)
						{
						
						}
						else
						{
							this.$vs.notify({
								title: 'SPSaude',
								text: 'Erro ao gerar btc!',
								iconPack: 'feather',
								icon: 'icon-alert-circle',
								color: 'danger'
							});
						}

					});*/
				}
			}
			
		},
    },
    components: {
        quillEditor,
        VuePerfectScrollbar
    }   
}
</script>